import type { UserPropertiesType } from "../../../types/common/userProperties";

export class UserPropertiesVM {
  msg: string = "";
  userProperties: UserPropertiesType | undefined = undefined;
}
